import { useForm } from "react-hook-form";
import validators from "../../utils/validators";
import FormCriarUsuarioPage from "./FormCriarUsuarioPage";
import { useSelector } from "react-redux";
import { getUsuario } from "../../selectors/usuarioAdm.selectors";

const FormDeletarUsuarioPageConnected = () => {
  const { loading } = useSelector(getUsuario);

  const rules = {
    nome: validators.string({ required: true }),
    email: validators.email({ required: true }),
    codigo: validators.string({ required: true }),
    perfil: validators.string({ required: true }),
  };

  const initialValues = {
    nome: "",
    email: "",
    codigo: "",
    perfil: "",
  };

  const formProps = {
    ...useForm(),
    rules,
    initialValues,
  };

  return <FormCriarUsuarioPage loading={loading} formProps={formProps} />;
};

export default FormDeletarUsuarioPageConnected;
